export const isValidUrl = (string: string) => {
  let url;
  try {
    url = new URL(string);
  } catch {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
};

export const hashEmail = async (email: string): Promise<string> => {
  if (!email) return "";
  const normalizedString = email.toLowerCase().trim();
  const msgBuffer = new TextEncoder().encode(normalizedString);
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return hashHex;
};

export const generateRandomString = () => {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
    "",
  );
};

export const ensurePresent = async <T>(
  predicate: () => T | null | undefined,
  timeout: number,
  pollingInterval: number = 100,
): Promise<T | null> => {
  const currentValue = predicate();
  if (currentValue !== undefined && currentValue !== null) {
    return currentValue;
  }
  let currentTimeout = 0;
  // At some point we would like to have progressive interval, meaning
  // the longer you wait the longer the interval becomes.
  const effectivePollingInterval = Math.min(timeout, pollingInterval);
  return new Promise<T | null>((resolve) => {
    setInterval(() => {
      currentTimeout += effectivePollingInterval;
      const value = predicate();
      if (value !== undefined && value !== null) {
        clearInterval(this);
        resolve(value);
      }
      if (currentTimeout >= timeout) {
        clearInterval(this);
        resolve(null);
      }
    }, effectivePollingInterval);
  });
};
